import React, { useState, useEffect } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import "../css/carousel.css";
import { Carousel } from 'react-responsive-carousel';
import { Container, Col, Row, Modal, Button } from "react-bootstrap";
import axios from "axios";

export default function Slides() {
    const [presentation, setpresentation] = useState([]);
    const imgCDNURL = process.env.REACT_APP_ABOUT203KLOAN_CDN_URL;
    
    useEffect(() => {
      // Get the slides from a JSON file hosted in the cdn
      async function fetchpresentation() {
        try {
          const slides = await axios.get(process.env.REACT_APP_PRESENTATION_CDN_URL);
          //console.log(memories.data);
          setpresentation(slides.data);
        } catch (err) {
          console.log(err);
        }
      }
      fetchpresentation();
    }, []);
  
    return (
      <div className="Slides">
        <>
          <Container>
            {presentation ?
              <Row>
                <Col>
                  <Carousel
                    axis="horizontal"
                    showArrows={true}
                    showIndicators={false}
                    showStatus={true}
                    showThumbs={false}
                    swipeable={true}
                  >
                    {presentation.map((item, i) => {
                      return (
                        <div>
                          <img
                            src={imgCDNURL + item.imgPath}
                            className="image1 img-fluid"
                            alt={"Slide " + i}
                            key={i}
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                </Col>
              </Row>
              : ""}
          </Container>
        </>
      </div>
    );
  }